if (!customElements.get('collection-bubbles')) {
  customElements.define('collection-bubbles', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.collection-bubbles__track');
      this.previous = this.querySelector('.collection-bubbles__previous');
      this.next = this.querySelector('.collection-bubbles__next');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.previous.addEventListener('click', () => this.scroll(-1), options);
      this.next.addEventListener('click', () => this.scroll(1), options);
      this.track.addEventListener('scroll', () => this.update(), options);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      for (const bubble of this.track.children) this.observer.observe(bubble);
      this.update();
    }

    scroll(direction) {
      const style = getComputedStyle(this.track);
      const rtl = style.direction === 'rtl';
      const distance = this.getAttribute('slide-by') === 'item'
        ? this.track.firstElementChild.getBoundingClientRect().width + parseFloat(style.columnGap)
        : this.track.clientWidth * 0.8;
      this.track.scrollBy({
        left: direction * (rtl ? -1 : 1) * distance,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }

    update() {
      const maximum = this.track.scrollWidth - this.track.clientWidth;
      const position = Math.abs(this.track.scrollLeft);
      this.previous.hidden = this.next.hidden = maximum <= 1;
      this.previous.disabled = position <= 1;
      this.next.disabled = position >= maximum - 1;
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
    }
  });
}
